import api from './api';

// Re-reads the current user (role and username) from the database and updates the stored copy.
// Dispatches 'user-updated' when something changed so the header and admin nav re-render.
// A 401 means the session is no longer valid, so the user is sent to log in again.
export default async function refreshCurrentUser() {
  const stored = JSON.parse(localStorage.getItem('user') || 'null');
  if (!stored) return;
  try {
    const { data } = await api.get('/api/users/me');
    const delegatedGroupCount = data.delegatedGroupCount || 0;
    if (data.role === stored.role && data.username === stored.username && delegatedGroupCount === (stored.delegatedGroupCount || 0)) return;
    localStorage.setItem('user', JSON.stringify({ ...stored, role: data.role, username: data.username, delegatedGroupCount }));
    window.dispatchEvent(new Event('user-updated'));
  } catch (err) {
    if (err.response?.status === 401) {
      localStorage.removeItem('user');
      localStorage.removeItem('token');
      window.location.href = '/login';
    }
  }
}
